export function route(routeName, parameters = [], query = {}) {
	let route = routeName.split("/").filter(function (value) {
		return value;
	});

	let replacements = route.filter(function (value) {
		return value.startsWith(":");
	});

	if ("string" === typeof parameters) {
		parameters = [parameters];
	}

	if (
		_.isObject(parameters) &&
		parameters.id
	) {
		parameters = [parameters];
	}

	parameters = Object.assign({}, parameters);

	parameters = _.mapKeys(parameters, function (value, key) {
		return !isNaN(key)
			? replacements[key]
			: ":" + key.replace(/^:/g, "");
	});

	parameters = _.mapValues(parameters, function (value) {
		if (!value) {
			return value;
		}
		return "string" === typeof value ? value : value.id;
	});

	route = route.filter(value => {
		if (!value.endsWith("?")) {
			return true;
		}

		return parameters.hasOwnProperty(value.replace(/\?$/, ""));
	});

	route = route.map(function (value) {
		if (!value.startsWith(":")) {
			return value;
		}
		return parameters[value.replace(/\?$/, "")] || null;
	});

	route = route.join("/").replace(/\/$/, "");

	query = Qs.stringify(query);
	if (query) {
		query = "?" + query;
	}

	return route + query;
}
